module.exports = __webpack_public_path__ + "static/greybunny4-798e5284ff85a6c443fdf8fbc36eec74.png";